import { casesOutputConfigurationOptions, } from './types';
export function isGetCaseOutputType(item) {
    return casesOutputConfigurationOptions.includes(item);
}
export function getReadableCaseID(caseID) {
    return caseID.substring(0, 8).toLocaleUpperCase();
}
